<template>
  <div class="rfp-rr-ratings-helpful-018-or rr-like-review clear float-left">
    <p class="rfp-rr-ratings-helpful-019-or">
      <span class="rfp-rr-ratings-helpful-020-or">{{ helpfulLabel }}</span>
    </p>
    <div class="rfp-rr-ratings-helpful-021-or rr-like-section float-left">
      <p
        v-if="helpfulCountCookieLocal != rrid && IsHelpfulCookie == 'no'"
        class="rfp-rr-ratings-helpful-022-or"
        @click="UpdateHelpfulReview"
      >
        <img
          :src="helpfulIconss"
          class="rfp-rr-ratings-helpful-023-or image-setup-for-list"
          :alt="helpfulIconAltss"
        />
      </p>
      <p v-else>
        <img
          :src="helpfulIconss"
          class="rfp-rr-ratings-helpful-024-or image-setup-for-list"
          :alt="helpfulIconAltss"
        />
      </p>
      <p>
        <span class="rfp-rr-ratings-helpful-025-or bold">{{ HelpfulCountsCount }}</span>
      </p>
      <p
        v-if="helpfulCountCookieLocal != rrid && IsHelpfulCookie == 'no'"
        class="rfp-rr-ratings-helpful-026-or"
        @click="UpdateNotHelpfulReview"
      >
        <img
          :src="nonHelpfulIconss"
          class="rfp-rr-ratings-helpful-027-or image-setup-for-list"
          :alt="nonHelpfulIconAltss"
        />
      </p>
      <p v-else>
        <img
          :src="nonHelpfulIconss"
          class="rfp-rr-ratings-helpful-028-or image-setup-for-list"
          :alt="nonHelpfulIconAltss"
        />
      </p>
      <p>
        <span class="rfp-rr-ratings-helpful-029-or bold">{{ NotHelpfulCountsCount }}</span>
      </p>
      <p>
        <a
          v-if="reportDisplayed != rrid && report == reportText"
          class="rfp-rr-ratings-helpful-030-or aReported"
          @click="ratingSummary"
          >{{ reportText }}</a
        >
        <a v-else class="rfp-rr-ratings-helpful-031-or aReported">{{ reportedText }}</a>
      </p>
      <p v-if="facebookShareEnabledss" class="rfp-ratings-social-share">
        <rfp-ratings-social-share
          :url="currentPageUrl"
          :title="productNamess"
          :description="reviewContentss"
          :quote="reviewTitless"
          :facebooks="facebookCaptionss"
          :show-fb-media-texts="shareDisplayConfigss"
          :facebook-icons="facebookIconss"
          :facebook-icon-alt="facebookIconAltss"
        >
          <social-sharing-network network="facebook">
            <p v-if="facebookIcons == ''">
              <span
                v-if="showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Icon'"
                class="rfp-ratings-fb-icon-sprite-small rfp-ratings-icon-size-circle-small"
              ></span>
            </p>
            <p v-else>
              <img
                v-if="
                  (facebookIcons != '' && showFbMediaTexts == 'Icon and Text') ||
                  showFbMediaTexts == 'Icon'
                "
                :src="facebookIcons"
                :title="facebookIconAlt"
                class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                :alt="facebookIconAlt"
              />
            </p>
            <span v-if="showFbMediaTexts == 'Icon and Text' || showFbMediaTexts == 'Text'">{{
              facebooks
            }}</span>
          </social-sharing-network>
        </rfp-ratings-social-share>
      </p>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import axios from 'axios';
import RfpRatingsSocialShare from '@/components/widget/rfp-ratings-social-share/Plugins/rfp-ratings-social-share.vue';
import SocialSharingNetwork from '@/components/widget/rfp-ratings-social-share/Plugins/social-sharing-network.js';

export default {
  name: 'rfp-ratings-helpful',
  components: {
    RfpRatingsSocialShare,
    SocialSharingNetwork,
  },
  props: {
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: true,
    },
    rrid: {
      type: Number,
      required: true,
    },
    reportDisplay: {
      type: Number,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    IsHelpfulCookie: {
      type: String,
      required: true,
    },
    HelpfulCount: {
      type: Number,
      required: true,
    },
    NotHelpfulCount: {
      type: Number,
      required: true,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReviewApi: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    helpfulIconss: {
      type: String,
      required: true,
    },
    helpfulIconAltss: {
      type: String,
      required: true,
    },
    nonHelpfulIconss: {
      type: String,
      required: true,
    },
    nonHelpfulIconAltss: {
      type: String,
      required: true,
    },
    productNamess: {
      type: String,
      required: true,
    },
    reviewContentss: {
      type: String,
      required: true,
    },
    reviewTitless: {
      type: String,
      required: true,
    },
    facebookCaptionss: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabledss: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfigss: {
      type: String,
      required: true,
    },
    facebookIconss: {
      type: String,
      default: '',
    },
    facebookIconAltss: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      reportDisplayed: this.reportDisplay,
      cookiesDetaild: [],
      helpfulCountCookieLocal: '',
      NotHelpfulCountsCount: this.NotHelpfulCount,
      HelpfulCountsCount: this.HelpfulCount,
      currentPageUrl: window.location.href,
    };
  },
  methods: {
    ratingSummary() {
      const reportedCookie = 'reportedCookie' + this.rrid;
      /* istanbul ignore next */
      axios
        .get('/refapp/RatingSummary/ReportReview?rrID=' + this.rrid + '', {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Message === 'Reported') {
            if (this.$cookies.get(reportedCookie) === 'success') {
              this.reportDisplayed = this.rrid;
            } else {
              this.reportDisplayed = '';
            }
          }
        });
    },
    UpdateHelpfulReview() {
      eventBus.emit('LikeReviewTags');
      const helpfulCountCookie = 'helpfulCountCookie' + this.rrid;
      /* istanbul ignore next */
      axios
        .get(this.updateHelpfulReviewApi + '?rrID=' + this.rrid, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Message === 'Success') {
            if (this.$cookies.get(helpfulCountCookie) === 'success') {
              this.helpfulCountCookieLocal = this.rrid;
              this.HelpfulCountsCount = response.data.Count;
            } else {
              this.helpfulCountCookieLocal = '';
            }
          }
        });
    },
    UpdateNotHelpfulReview() {
      eventBus.emit('unLikeReviewTags');
      const helpfulCountCookie = 'helpfulCountCookie' + this.rrid;
      /* istanbul ignore next */
      axios
        .get(this.updateNotHelpfulReviewApi + '?rrID=' + this.rrid, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Message === 'Success') {
            if (this.$cookies.get(helpfulCountCookie) === 'success') {
              this.helpfulCountCookieLocal = this.rrid;
              this.NotHelpfulCountsCount = response.data.Count;
            } else {
              this.helpfulCountCookieLocal = '';
            }
          }
        });
    },
  },
};
</script>
